<div class="change-password-overlay">
  <div
    class="change-password-panel"
    [class.change-password-panel--welcome]="isForced"
    (click)="$event.stopPropagation()"
  >
    @if (isForced) {
      <div class="welcome-banner" aria-live="polite">
        <div class="welcome-banner__media" aria-hidden="true">
          <img
            class="welcome-banner__gif"
            [src]="welcomeMediaSrc"
            alt=""
            width="72"
            height="72"
            decoding="async"
            fetchpriority="low"
          />
         
        </div>
        <div class="welcome-banner__copy">
          <p class="welcome-banner__eyebrow">YOU'RE ALL SET!</p>
          <h2 class="welcome-banner__title">Welcome, {{ welcomeUserName }} </h2>
          <p class="welcome-banner__subtitle">
            We're excited to have you here.<br />
            Let's secure your account with a strong password.
          </p>
        </div>
      </div>
    }

    @if (!isForced) {
      <div class="panel-header">
        <div class="header-content">
          <mat-icon class="header-icon">lock</mat-icon>
          <h2 class="modal-title">Change Password</h2>
        </div>
        <button class="close-btn" type="button" (click)="onCancel()" aria-label="Close">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    }

    <div class="panel-body">
      <form [formGroup]="changePasswordForm" (ngSubmit)="onSubmit()">
        <div class="modal-cnt">
          @if (!isForced) {
          <div class="form_field_wrapper">
            <input
              [type]="hideCurrentPassword ? 'password' : 'text'"
              name="oldPassword"
              required
              placeholder=" "
              class="form-control"
              [formControl]="oldPasswordControl"
              [class.ng-invalid]="changePasswordForm.get('oldPassword')?.invalid && changePasswordForm.get('oldPassword')?.touched"
              [class.ng-touched]="changePasswordForm.get('oldPassword')?.touched"
            />
            <label class="floating_label">Current Password *</label>
            <button
              type="button"
              class="toggle-password"
              (click)="hideCurrentPassword = !hideCurrentPassword"
            >
              {{ hideCurrentPassword ? 'Show' : 'Hide' }}
            </button>
            @if (showFieldError('oldPassword')) {
              <div class="mat-error">{{ getFieldError('oldPassword') }}</div>
            }
          </div>
          }
          <div class="form_field_wrapper">
            <input
              [type]="hideNewPassword ? 'password' : 'text'"
              name="newPassword"
              required
              placeholder=" "
              class="form-control"
              [maxlength]="passwordMaxLength"
              [formControl]="newPasswordControl"
              [class.ng-invalid]="changePasswordForm.get('newPassword')?.invalid && changePasswordForm.get('newPassword')?.touched"
              [class.ng-touched]="changePasswordForm.get('newPassword')?.touched"
            />
            <label class="floating_label">New Password</label>
            <button
              type="button"
              class="toggle-password"
              (click)="hideNewPassword = !hideNewPassword"
            >
              {{ hideNewPassword ? 'Show' : 'Hide' }}
            </button>
            @if (showFieldError('newPassword')) {
              <div class="mat-error">{{ getFieldError('newPassword') }}</div>
            }
          </div>

          <div class="form_field_wrapper">
            <input
              [type]="hideConfirmPassword ? 'password' : 'text'"
              name="confirmPassword"
              required
              placeholder=" "
              class="form-control"
              [maxlength]="passwordMaxLength"
              [formControl]="confirmPasswordControl"
              [class.ng-invalid]="(changePasswordForm.get('confirmPassword')?.invalid || changePasswordForm.hasError('mismatch')) && (changePasswordForm.get('confirmPassword')?.touched || changePasswordForm.get('confirmPassword')?.dirty)"
              [class.ng-touched]="changePasswordForm.get('confirmPassword')?.touched"
            />
            <label class="floating_label">Confirm Password</label>
            <button
              type="button"
              class="toggle-password"
              (click)="hideConfirmPassword = !hideConfirmPassword"
            >
              {{ hideConfirmPassword ? 'Show' : 'Hide' }}
            </button>
            @if (showFieldError('confirmPassword')) {
              <div class="mat-error">{{ getFieldError('confirmPassword') }}</div>
            }
          </div>
        </div>

        <div class="form-actions" [class.form-actions--forced]="isForced">
          @if (isForced) {
            <a
              class="logout-link"
              href="javascript:void(0)"
              role="button"
              (click)="onLogout(); $event.preventDefault()"
              [attr.aria-disabled]="isLoggingOut()"
              [class.logout-link--disabled]="isLoggingOut()"
            >
              @if (isLoggingOut()) {
                <app-spinner [size]="16" class="button-spinner"></app-spinner>
              } @else {
                <mat-icon class="logout-link__icon" aria-hidden="true">logout</mat-icon>
              }
              <span>Logout</span>
            </a>
          }
          <div class="form-actions__right">
            <button
              mat-flat-button
              color="primary"
              type="submit"
              [disabled]="loading() || isLoggingOut()"
            >
              @if (loading()) {
                <app-spinner [size]="16" class="button-spinner"></app-spinner>
              } @else {
                Save Password
              }
            </button>
            @if (!isForced) {
              <button
                class="btn-cancel"
                mat-stroked-button
                type="button"
                (click)="onCancel()"
              >
                Cancel
              </button>
            }
          </div>
        </div>

        <div class="security-note" aria-live="polite">
          <span class="security-note__icon-wrap" aria-hidden="true">
            <mat-icon class="security-note__icon">gpp_good</mat-icon>
          </span>
          <p class="security-note__text">
            <!-- <span class="security-note__title">Your security is our priority.</span> -->
            This helps keep your account safe and protected.
          </p>
        </div>
      </form>
    </div>
  </div>
</div>
